<template>
  <div v-if="!hidden" class="mb-16">
    <QuestionLabel :text="question.text" class="mt-1"></QuestionLabel>
    <table class="pb-6">
      <thead>
        <th class="pl-0 pb-4"></th>
        <th class="vertical-align-bottom text-right text-capitalize">
          Percentage
        </th>
      </thead>
      <tr v-for="option in question.options" :key="option.value">
        <td class="w-100">{{ option.text }}</td>
        <td class="text-right text-no-wrap">
          {{ getRate(option) | percentage }}
        </td>
      </tr>
    </table>
  </div>
</template>

<style scoped lang="scss">
$blueFill: rgba(101, 146, 230, 0.15);
$greyFill: rgba(0, 0, 0, 0.05);

table {
  border-collapse: collapse; /* Remove cell spacing */

  thead {
    th {
      vertical-align: bottom;
      text-align: center;
      padding-top: 0.5rem;
      border-radius: 0.5rem 0.5rem 0 0;
      padding: 0.5rem 1rem 0.25rem 1rem;

      &:nth-child(even) {
        background: $greyFill;
      }
    }
  }

  th,
  td {
    padding: 0.25rem 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    text-align: left;
  }

  tr,
  tfoot {
    &:nth-child(odd) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
    &:nth-child(even) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
  }

  tr {
    &:hover {
      background: rgba(0, 0, 0, 0.15) !important;

      td {
        border-color: rgba(0, 0, 0, 0.25);
      }
    }

    &:nth-child(even) {
      background: $blueFill;
    }
  }

  tfoot {
    td {
      border-radius: 0 0 0.5rem 0.5rem;
      padding: 0.5rem;
    }
  }
}
</style>

<script>
import numeral from "numeral";

import QuestionLabel from "./QuestionReport.Label.vue";

export default {
  name: "QuestionReportResponseRate",
  components: { QuestionLabel },
  filters: {
    percentage(val) {
      return numeral(val).format("0.00%");
    },
  },
  data: () => ({}),
  props: {
    survey: Object,
    question: Object,
    agg: Object,
    dense: Boolean,
  },
  computed: {
    questionData() {
      var results = this.agg.results.filter((x) => x.key === this.question.key);
      if (results.length == 0) return null;
      else return results[0];
    },
    hidden() {
      return this.settings.private === "true";
    },
    settings() {
      var result = {};

      this.question.settings.forEach((x) => {
        result[x.key] = x.value;
      });

      return result;
    },
  },
  methods: {
    getRate(option) {
      if (!this.questionData) return 0;

      var numerator =
        this.questionData.counts.find((x) => x.key === option.value)?.value ??
        0;
      var denominator = 0;

      if (option.responseCountTarget) denominator = option.responseCountTarget;
      else if (this.question.responseCountTarget)
        denominator = this.question.responseCountTarget;
      else if (this.survey.responseCountTarget)
        denominator = this.survey.responseCountTarget;
      else if (this.questionData.responses)
        denominator = this.questionData.responses;
      else denominator = this.agg.responseCount;

      if (!numerator) return 0;
      else return numerator / denominator;
    },
  },
};
</script>
